import { businessPlanAxios } from 'services/controllers/businessPlan';

import { IUseFieldArrayProduct } from 'components/BusinessToolForm/Sections/Global/general/products';

import * as t from './types';

export const GlobalProductsApi = {
  createProduct: async (businessPlanId: string) => {
    const { data } = await businessPlanAxios.post<t.ICreateProductResponse>(`/${businessPlanId}/product`);
    return data;
  },

  deleteProduct: async (params: t.IDeleteProduct) => {
    const { id } = params;
    await businessPlanAxios.delete(`/product/${id}`);
  },

  getProducts: async (businessPlanId: string) => {
    const { data } = await businessPlanAxios.get<IUseFieldArrayProduct[]>(`/${businessPlanId}/product`);
    return data;
  },
};
